import { Camera, MessageCircle } from "lucide-react";
import { PROJECTS, waLink } from "@/lib/brand";

export const Projects = () => {
  return (
    <section
      id="projetos"
      data-testid="projects-section"
      className="relative py-24 lg:py-36 bg-[#050505] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-[#facc15]" />
              <span className="text-[11px] uppercase tracking-[0.32em] text-[#facc15] font-bold">
                Projetos que falam por si
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-white">
              Ambientes transformados em
              <span className="italic text-[#facc15]"> obras de arte</span>.
            </h2>
          </div>
          <p className="lg:col-span-4 lg:col-start-9 self-end text-zinc-400 leading-relaxed">
            Projetos residenciais e comerciais entregues em{" "}
            <span className="text-white">Florianópolis, São José, Palhoça e Biguaçu</span>
            {" "}— esquadrias modernas, fachadas elegantes, sacadas sofisticadas
            e fechamentos em vidro de alto padrão.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {PROJECTS.map((p, i) => (
            <article
              key={i}
              data-testid={`project-${i}`}
              className={`relative bg-[#0a0a0a] overflow-hidden group ${
                i === 0
                  ? "lg:col-span-2 lg:row-span-2 lg:min-h-[640px] aspect-[4/5] lg:aspect-auto"
                  : "aspect-[4/5]"
              }`}
            >
              <img
                src={p.src}
                alt="Projeto entregue pela ATL Esquadrias"
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />

              {/* Hover overlay with CTA */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-end p-6 lg:p-8">
                <p className="font-display text-lg lg:text-xl text-white leading-tight">
                  Gostou deste projeto?
                  <br />
                  <span className="text-[#facc15] italic">
                    Solicite um orçamento semelhante.
                  </span>
                </p>
                <a
                  href={waLink(
                    "Olá! Gostei deste projeto no site. Quero um orçamento semelhante."
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`project-${i}-whatsapp-btn`}
                  className="mt-4 inline-flex items-center gap-2 px-5 py-3 bg-[#facc15] text-black font-bold uppercase text-[10px] sm:text-[11px] tracking-[0.22em] hover:bg-white transition-colors self-start"
                >
                  <MessageCircle size={14} strokeWidth={2} />
                  Orçamento no WhatsApp
                </a>
              </div>

              {/* Hover frame */}
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-[#facc15]/60 transition-colors duration-500" />
            </article>
          ))}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between border-t border-white/10 pt-10">
          <div className="flex items-center gap-3 text-zinc-400">
            <Camera size={18} strokeWidth={1.5} />
            <p className="text-sm">
              Projetos reais entregues pela ATL Esquadrias em Santa Catarina.
            </p>
          </div>
          <a
            href={waLink("Olá! Gostaria de ver mais projetos da ATL Esquadrias.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="projects-whatsapp-btn"
            className="inline-flex items-center gap-3 px-6 py-4 bg-[#facc15] text-black font-bold uppercase text-[11px] tracking-[0.28em] hover:bg-white transition-colors"
          >
            Solicite uma consultoria técnica →
          </a>
        </div>
      </div>
    </section>
  );
};
